import { render, staticRenderFns } from "./QuickBuilder.vue?vue&type=template&id=ad130328"
import script from "./QuickBuilder.vue?vue&type=script&lang=js"
export * from "./QuickBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports